export enum ReasonForChange {
  rebrand = 'rebrand',
  incorrectMatching = 'incorrect-match',
}

export const ReasonsForChangeLabels: Record<ReasonForChange, string> = {
  [ReasonForChange.rebrand]: 'Rebrand',
  [ReasonForChange.incorrectMatching]: 'Incorrect Matching',
};
